<script setup lang="ts" >
import { Vue3Lottie } from 'vue3-lottie'
import { useI18n } from "vue-i18n";
import emojiJson from '@/assets/mood_positive_friendly.json';
import { buildMeta } from '~~/utils/meta-builder';
interface FAQ {
  id: string
  question: string
  answer: string
}

useHead(buildMeta({ key:'help', follow: true, htmlAttrs: {
	itemscope: "itemscope",
	itemtype: 'https://schema.org/FAQPage'
	} })) 

	const i18n = useI18n();
	const config = useRuntimeConfig()
	const email = config.public.email

	const supportEmail = ref(`<a class="text-link" href="mailto:${email.support}">${email.support}</a>`)
	const otherEmail = ref(`<a class="text-link" href="mailto:${email.other}">${email.other}</a>`)
	const pressEmail = ref(`<a class="text-link" href="mailto:${email.press}">${email.press}</a>`)
	const jobsEmail = ref(`<a class="text-link" href="mailto:${email.jobs}">${email.jobs}</a>`)
	const partnerEmail = ref(`<a class="text-link" href="mailto:${email.partner}">${email.partner}</a>`)
	const privacyEmail = ref(`<a class="text-link" href="mailto:${email.privacy}">${email.privacy}</a>`)

	const tm = <any>i18n.tm('help.faq')
	let id = 0;
	const list = <FAQ[]>tm.map((item: any)=><FAQ>{id: `faq-${id++}`, question: i18n.rt(item.question), answer: i18n.rt(item.answer, {
		'email_support': supportEmail.value,
		'email_press': pressEmail.value,
		'email_jobs': jobsEmail.value,
		'email_partner': partnerEmail.value,
		'email_privacy': privacyEmail.value,
		'email': otherEmail.value,
	})})
	
	const searchQuery = ref("")
	const searchFaq = computed(() => {
		if(searchQuery.value === "")return list
		return list.filter((item) => {
			const sq = searchQuery.value.toLowerCase()
			return (
				item.question.toLowerCase().indexOf(sq) != -1
				|| 
				item.answer.toLowerCase().indexOf(sq) != -1
			);
		});
	});

	/*
	const chat = ref(`<a class="text-link" target="_blank" href="https://tawk.to/chat/62d3ab437b967b117999e856/1g85da0mk">Chat</a>`)
	if(process.client){
			var Tawk_API:any=Tawk_API||{}, Tawk_LoadStart=new Date();
		(function(){
			var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
			s1.async=true;
			s1.src='https://embed.tawk.to/62d3ab437b967b117999e856/1g85da0mk';
			s1.charset='UTF-8';
			s1.setAttribute('crossorigin','*');
			s0.parentNode?.insertBefore(s1,s0);
		})();
	}*/
	
</script>

<template>
  <div>
    <div class="w-full relative ">
        <div class="w-full h-full absolute -z-10 overflow-x-hidden">
            <div class="header w-full h-full">
              <svg class="absolute right-0" width="688" height="780" viewBox="0 0 688 780" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112467)">
                <circle cx="522.5" cy="257.5" r="278.5" fill="#FFA5A5" fill-opacity="0.79"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112467" x="0" y="-265" width="1045" height="1045" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="122" result="effect1_foregroundBlur_14818_112467"/>
                </filter>
                </defs>
              </svg>

               <svg class="absolute" width="377" height="565" viewBox="0 0 377 565" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112466)">
                <circle cx="9" cy="197" r="194" fill="#B5FBFF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112466" x="-359" y="-171" width="736" height="736" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="87" result="effect1_foregroundBlur_14818_112466"/>
                </filter>
                </defs>
              </svg>

              <svg class="mx-auto" width="1131" height="612" viewBox="0 0 1131 612" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112468)">
                <circle cx="590" cy="22" r="206" fill="#A864FF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112468" x="0" y="-568" width="1180" height="1180" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="192" result="effect1_foregroundBlur_14818_112468"/>
                </filter>
                </defs>
              </svg>

            </div>
        </div>
        <Header theme="light" />
        <div class="max-w-screen-lg gap-10 px-6 md:px-20 lg:px-10 pt-10 mx-auto items-center justify-center">
          
            <div class="flex flex-col text-center md:text-left flex-1 pb-20 md:w-3/4">
             
              <div class="felx flex-col md:flex-row inline-flex mx-0">
								<client-only> 
                  <Vue3Lottie
                      alt="smoxy emoji with happy mood"
                      class="emoji flex md:-translate-x-10 w-[100px]"
                      width="100"
                      height="100"
                      :animationData="emojiJson" 
                      :loop="true" />
								</client-only> 
                <h1 class="text-6xl lg:text-7xl font-owners font-bold pb-4 pt-2 md:-translate-x-10" v-html="$t('help.headline')"></h1>
              </div>
               
              <p class="text-black/75 text-2xl mt-10">{{$t('help.body')}}</p>
            </div>
        </div>
       
        <div class="max-w-screen-lg px-6 md:px-10 lg:px-6 mx-auto pb-20 faq">
          <input type="text" :placeholder="$t('help.search_placeholder')" v-model="searchQuery" 
					class="appearance-none placeholder:text-black/50 block w-full focus:outline-none mb-20 p-4 pr-12 text-md text-black border-black/20 rounded-lg bg-black/5" />
                    
          <div class="grid grid-cols-1 md:grid-cols-3 w-full gap-10">
            
            <div class="col-span-2">
              <div v-for="item in searchFaq" 
                :key="item.id"
                class="text-sm border-t border-b border-black/10">
            
                <FAQItem
                    :question="item.question" 
                    :answer="item.answer"
                />     
            </div>
            </div>

            <div class="col-span-1">
              <h2 class="text-2xl font-bold font-owners pt-10 md:pt-4">{{$t('help.support.title')}}</h2> 
              <p class="text-md mt-2 pb-10" v-html="$t('help.support.body', {'email_support': supportEmail, 'chat': chat })"></p>
            </div>
          </div>
        </div>

    </div> 


    <Footer />
   
  </div>
</template>

<style>
.faq a {
  color: #7E1EF8;
  font-weight: 500;
}
.emoji {
	filter: drop-shadow(0px 5px 25px rgba(255, 170, 0, 0.8)) hue-rotate(230deg);
}
</style>

